module.exports = __webpack_public_path__ + "img/IMG_20191130_012057.d66b5efa.jpg";